
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/list-business",
      function () {
        return require("private-next-pages/list-business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/list-business"])
      });
    }
  